import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { hasRouteAccess } from './RouteUtils';

/**
 * A route wrapper that enforces role-based access control
 */
const ProtectedRoute = ({ children, path }) => {
  const location = useLocation();
  const roleName = localStorage.getItem('roleName');
  const isAuthenticated = sessionStorage.getItem('token');
  
  // Not authenticated - redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  
  // Check permissions
  const hasAccess = hasRouteAccess(path, roleName);
  
  // No access - redirect to unauthorized
  if (!hasAccess) {
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }
  
  // Access granted - render the protected component
  return children;
};

export default ProtectedRoute;